module.exports = __webpack_public_path__ + "b9d46e844303f78d3bb800d5ce302a07.png";